import axios from 'axios';
import { instagramConfig } from './config';

export async function getAuthUrl(redirectUri, connectionId) {
  console.log('Instagram env vars:', {
    clientId: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
    hasSecret: !!process.env.REACT_APP_FACEBOOK_CLIENT_SECRET
  });

  const stateObj = {
    service: 'instagram_page',
    connectionId: connectionId
  };
  
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
    redirect_uri: redirectUri,
    state: btoa(JSON.stringify(stateObj)),
    scope: [
      'instagram_basic',
      'instagram_content_publish',
      'instagram_manage_insights',
      'pages_show_list',
      'pages_read_engagement',
      'business_management'
    ].join(','),
    display: 'popup',
    auth_type: 'rerequest'
  });

  const authUrl = `${instagramConfig.authEndpoint}?${params.toString()}`;
  console.log('Generated Instagram auth URL:', authUrl);
  return authUrl;
}

export async function exchangeCodeForToken(code, redirectUri) {
  try {
    console.log('Starting Instagram token exchange process...');
    
    // Exchange code for access token
    const tokenResponse = await axios.get(
      `${instagramConfig.tokenEndpoint}?${new URLSearchParams({
        client_id: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
        client_secret: process.env.REACT_APP_FACEBOOK_CLIENT_SECRET,
        redirect_uri: redirectUri,
        code: code
      }).toString()}`
    );

    const accessToken = tokenResponse.data.access_token;

    // Get Facebook pages with Instagram accounts
    const pagesResponse = await axios.get(
      'https://graph.facebook.com/v17.0/me/accounts',
      {
        params: {
          access_token: accessToken,
          fields: 'id,name,access_token,instagram_business_account{id,name,username,profile_picture_url,followers_count,media_count,biography}'
        }
      }
    );

    console.log('Pages response:', pagesResponse.data);

    // Extract Instagram accounts from pages
    const instagramAccounts = pagesResponse.data.data
      .filter(page => page.instagram_business_account)
      .map(page => ({
        id: page.instagram_business_account.id,
        name: page.instagram_business_account.name,
        username: page.instagram_business_account.username,
        picture: page.instagram_business_account.profile_picture_url,
        followersCount: page.instagram_business_account.followers_count,
        mediaCount: page.instagram_business_account.media_count,
        biography: page.instagram_business_account.biography,
        pageId: page.id,
        pageName: page.name,
        accessToken: page.access_token // Store the page's access token for API calls
      }));

    console.log('Available Instagram accounts:', instagramAccounts);

    return {
      success: true,
      data: {
        accessToken: accessToken,
        expiresIn: tokenResponse.data.expires_in,
        accounts: instagramAccounts
      }
    };
  } catch (error) {
    console.error('Instagram auth error:', error.response?.data || error);
    return {
      success: false,
      error: error.response?.data?.error || error.message
    };
  }
}

export async function testConnection(credentials) {
  try {
    // Test the connection by getting the account info
    const response = await axios.get(
      `${instagramConfig.graphEndpoint}/me/accounts`,
      {
        params: {
          access_token: credentials.accessToken,
          fields: 'instagram_business_account{id,name}'
        }
      }
    );

    // Check if we can still access the Instagram account
    const instagramAccounts = response.data.data
      .filter(page => page.instagram_business_account)
      .map(page => ({
        id: page.instagram_business_account.id,
        name: page.instagram_business_account.name
      }));

    if (instagramAccounts.length === 0) {
      throw new Error('No Instagram business accounts found');
    }

    return {
      success: true,
      data: instagramAccounts
    };
  } catch (error) {
    console.error('Instagram test connection error:', error.response?.data || error);
    return {
      success: false,
      error: error.response?.data?.error?.message || error.message
    };
  }
} 